import { logout as nodeLogout } from '@pba/client-auth';
import { resetAllStores } from 'lib/zustand';
import { queryClient } from 'query/query-client';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import { clearRailsTokens } from '../auth';
import { clearNodeToken } from '../node-api/auth';

// TODO: add here some form of flow handling
export const logout = async () => {
  await nodeLogout({});
  clean();
};

export const clean = () => {
  resetAllStores();
  clearNodeToken();
  window.referrer = undefined;
  queryClient.clear();
  sessionStorage.clear();
  clearRailsTokens();
};

export const useLogout = () => {
  const navigateFunction = useNavigate();

  return useCallback(
    async ({ navigate = true } = {}) => {
      await logout();

      if (navigate) {
        await navigateFunction(routes.login.index);
      }
    },
    [navigateFunction],
  );
};
